import Input from './Input';
import Errors from '../components/Errors';
import Loading from 'vue-loading-overlay';
import ProcessorHostedFieldsForm from '../components/Purchase/BraintreeHostedFieldsForm';
import VueRecaptcha from 'vue-recaptcha';
import api from "../api";
import startCase from 'lodash/startCase';

export default {
    components: {
        Errors,
        Loading,
        ProcessorHostedFieldsForm,
        VueRecaptcha,
    },
    props: {
        useRecaptcha: {
            type: Boolean,
            default: true,
        },
        user: {
            type: Object,
            required: false,
            default: null,
        },
    },
    validations: {
        formData: {
            //
        },
    },
    mixins: [
        Input,
    ],
    data() {
        return {
            errors: [],
            errorFields: {},
            formData: {},
            formId: 'purchaseForm',
            loading: false,
            recaptchaValid: true,
            recaptchaVerified: null,
            recaptchaSiteKey: process.env.MIX_APP_GOOGLE_RECAPTCHA_SITE_KEY,
        };
    },
    methods: {
        async checkout() {
            return api.checkout(this.formData);
        },
        clearErrors() {
            this.errors = [];
            this.errorFields = {};
        },
        errorMessages() {
            const fields = Object.keys(this.$v.formData.$model);
            fields.forEach((field) => {
                const rules = this.$v.formData[field];
                if (rules && rules.$anyError) {
                    this.setRequiredFieldErrorMessages(field, rules);
                    this.setErrorMessages(field, rules);
                }
            });
        },
        async getBillingValues() {
            return {
                //
            };
        },
        getRecaptchaResponse() {
            return window.grecaptcha.getResponse();
        },
        async initializeCheckout() {
            this.loading = true;
            this.clearErrors();

            if (! this.onInitializeCheckout()) {
                this.loading = false;
                return;
            }

            this.$v.$touch();
            this.onValidation();

            if (this.total !== '0.00') {
                const billingValidation = await this.validateBilling();
                if (Array.isArray(billingValidation)) {
                    this.errors = [...this.errors, ...billingValidation];
                }
            }

            // check formData validation
            if (this.$v.$error || this.errors.length > 0) {
                this.errorMessages();
                this.loading = false;
                this.scrollToErrors();
                return;
            }

            // get billing values and append to formData
            try {
                const billingValues = await this.getBillingValues();
                if (!billingValues && this.errors.length === 0) {
                    this.$noty.success('Checkout successfully canceled.');
                    this.loading = false;
                    return;
                }
                Object.keys(billingValues).forEach((key) => {
                    this.formData[key] = billingValues[key];
                });
            } catch (e) {
                this.loading = false;
                console.debug(e.code);
                if (!this.processClientError(e.code)) {
                    this.$noty.error('An unexpected error occurred processing your payment. Please try a different card.');
                }
                return;
            }

            // If using 3D secure card, ignore the recaptcha
            if (this.useRecaptcha && (this.total === '0.00' || this.formData.threeDSecureEnabled !== true)) {
                if (this.recaptchaVerified === false) {
                    this.errors.push('It looks like the ReCaptcha challenge expired. Please complete it and resubmit the form.');
                    this.errorMessages();
                    this.loading = false;
                    this.scrollToErrors();
                    return;
                } else {
                    this.formData.gRecaptchaResponse = this.getRecaptchaResponse();
                }
            }

            this.onBeforeProcessCheckout();
            return this.processCheckout();
        },
        onBeforeProcessCheckout() {
            //
        },
        onFailedCheckout(error) {
            //
        },
        onInitializeCheckout() {
            return true;
        },
        onProcessorLoading(ready) {
            this.loading = ready;
        },
        onRecaptchaExpired() {
            this.resetRecaptcha();
            this.recaptchaVerified = false;
        },
        onRecaptchaVerified() {
            this.recaptchaVerified = true;
            this.recaptchaValid = true;
        },
        onRecaptchaError() {
            this.reset();
            this.recaptchaValid = false;
            this.$noty.error('Please try the captcha again or reload the page.', {
                killer: true
            });
        },
        onValidation() {
            //
        },
        async processCheckout() {
            this.loading = true;
            try {
                const response = await this.checkout();
                if (response.data.redirect && response.data.redirect !== (typeof response.data.redirect !== 'undefined')) {
                    this.loading = true;
                    window.location = response.data.redirect;
                }
            } catch (error) {
                this.$noty.error('There was an error processing your purchase, please fix the issues above and try again.', {
                    killer: true
                });
                const data = error.response.data || {};
                if (data.errors) {
                    this.processServerErrors(data.errors)
                } else if (data.message) {
                    this.errors = [data.message];
                }

                this.scrollToErrors();
                this.onFailedCheckout(error);
            } finally {
                this.loading = false;
                if (this.useRecaptcha) {
                    this.resetRecaptcha();
                }
            }
        },
        processClientError(key) {
            return false;
        },
        processServerError(key) {
            return false;
        },
        processServerErrors(errors) {
            const normalize = (e) => Array.isArray(e) ? e.join(', ') : e;
            Object.keys(errors).forEach((key) => {
                let e = null;
                if (key === 'gRecaptchaResponse' && this.useRecaptcha) {
                    this.recaptchaValid = false;
                    this.recaptchaVerified = false;
                    e = normalize(errors[key][0]);
                } else if (key in this.formData || this.processServerError(key)) {
                    e = normalize(errors[key]);
                    this.errorFields[key] = e;
                }
                if (e) {
                    this.errors.push(normalize(e));
                }
            });
        },
        resetRecaptcha() {
            this.recaptchaVerified = null;
            window.grecaptcha.reset();
        },
        setErrorMessages(field, rules) {
            //
        },
        setRequiredFieldErrorMessages(field, rules) {
            if (!rules.required) {
                this.errorFields[field] = 'This field is required.';
                this.errors.push(`${startCase(field)} is required.`);
            }
        },
        scrollToErrors() {
            let form = document.getElementById(this.formId);
            form.scrollIntoView({ behavior: "smooth" });
            this.loading = false;
        },
        async validateBilling() {
            return true;
        },
    },
};
